import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Fetch, baseUrl } from '../../shared/Fetch';
import { JVInput } from '../../shared/JVInput';
import { RadioButton } from 'primereact/radiobutton';
import { ILogin } from '../../models/Login';

interface IProps {
  singleData: any;
  open: boolean;
  hideDialog: () => void;
  toast: any;
}

interface IMail {
}

const schema = yup.object({
});


export const CompanyDocumentMail = (props: IProps) => {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState<any[]>([]);
  const [tableData1, setTableData1] = useState<any[]>([]);
  const [tableData2, setTableData2] = useState<any[]>([]);
  const [selectedDocuments, setSelectedDocuments] = useState<any[]>([]);
  const [selectedCompanyDetails, setSelectedCompanyDetails] = useState<any[]>([]);
  const [selectedSignatory, setSelectedSignatory] = useState<any>(null); 

  const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

  const { control, handleSubmit, formState: { errors }, reset } = useForm<IMail>({
    resolver: yupResolver(schema),
    shouldFocusError: false,
  });

  const loadTableData = async () => {
    setLoading(true);
    const response = await Fetch('Company_Mast/getDocumentList', 'GET', null, `company_ID=${props.singleData.company_ID}`, props.toast);
    if (response) {
      const data = await response.json();
      setTableData(data);
    } else {
      props.toast.current.show({ severity: 'error', detail: 'Failed To Load Documents', life: 3000 });
    }
    setLoading(false);
  };

  const loadSignatoryData = async () => {
    setLoading(true);
    const response = await Fetch('Company_Mast/getSignaturecompanyDetails', 'GET', null, `company_ID=${props.singleData.company_ID}`, props.toast);
    if (response) {
      const data = await response.json();
      setTableData2(data);
    } else {
      props.toast.current.show({ severity: 'error', detail: 'Failed To Load Documents', life: 3000 });
    }
    setLoading(false);
  };


  const loadCompanyDetails = async () => {
    setLoading(true);
    const response = await Fetch('Company_Mast/getCompanyDetails', 'GET', null, `company_ID=${props.singleData.company_ID}`, props.toast);
    if (response) {
      const data = await response.json();
      console.log(data);
      const comapnyDetail1 = [{ 'key': "Company Name", 'value': data[0].company_Name }, { 'key': "FEID", 'value': data[0].feid }, { 'key': "Address", 'value': data[0].company_Address }, { 'key': "City", 'value': data[0].city_Name }, { 'key': "ZIP", 'value': data[0].company_Zip }];
      setTableData1(comapnyDetail1);
    } else {
      props.toast.current.show({ severity: 'error', detail: 'Failed To Load Documents', life: 3000 });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (props.open) {
      loadTableData();
      loadCompanyDetails();
      loadSignatoryData();
    }
  }, [props.open]);

  const onHide = () => {
    props.hideDialog();
    reset();
    setSelectedDocuments([]);
    setSelectedSignatory(null);
    setSelectedCompanyDetails([]);

  };

  const sendMail = async (fbody: IMail | any) => {
    if (selectedDocuments.length === 0 && selectedSignatory == null && selectedCompanyDetails.length == 0) {
      props.toast.current.show({ severity: 'error', detail: 'Please select at least one document.', life: 3000 });
      return;
    }
    setLoading(true);
    const attachments = [
      ...selectedDocuments.map(doc => doc.document_Path),
      //...selectedSignatory.map(doc => doc.signature),
    ];
    let signatoryName = null;
    signatoryName = selectedSignatory?.id;

    const companyDetailsJson = selectedCompanyDetails.reduce((acc, detail) => {
      acc[detail.key] = detail.value;
      return acc;
    }, {});

    const payload = {
      ...fbody,
      signatoryName: selectedSignatory?.id ? selectedSignatory?.id : null,
      attachments: attachments,
      emailbody: JSON.stringify(companyDetailsJson)
    };

    console.log("Payload:", payload);

    const response = await Fetch('Company_Mast/mail', 'POST', payload, null, props.toast);
    if (response) {
      let xyzData: any = await response.json();
      onHide();
      props.toast.current.show({ severity: 'success', detail: "mail sent successfully to " + xyzData.email, life: 3000 });
    }
    setLoading(false);
  };



  const onSubmit = (data: IMail) => {
    sendMail(data);
  };

  const onDocumentSelect = (rowData: any) => {
    const selected = [...selectedDocuments];
    const index = selected.findIndex(doc => doc.document_ID === rowData.document_ID);
    if (index === -1) {
      selected.push(rowData);
    } else {
      selected.splice(index, 1);
    }
    setSelectedDocuments(selected);
  };

  // Company detail selection
  const onCompanyDetailSelect = (rowData: any) => {
    const updatedSelection = selectedCompanyDetails.some((detail) => detail.key === rowData.key)
      ? selectedCompanyDetails.filter((detail) => detail.key !== rowData.key)
      : [...selectedCompanyDetails, rowData];
    setSelectedCompanyDetails(updatedSelection);
  };

  // Checkbox for selected Documnet
  const documentCheckboxTemplate = (rowData: any) => (
    <Checkbox checked={selectedDocuments.some((doc) => doc.document_ID === rowData.document_ID)} onChange={() => onDocumentSelect(rowData)} />
  );
// Checkbox for selected Company details
  const companyDetailCheckboxTemplate = (rowData: any) => (
    <Checkbox checked={selectedCompanyDetails.some((detail) => detail.key === rowData.key)} onChange={() => onCompanyDetailSelect(rowData)} />
  );

  //Checkboxe for selected signatory information
  const signatoryCheckboxSelect = (rowData: any) => (
    <RadioButton value={rowData} onChange={(e) => setSelectedSignatory(e.value)} checked={selectedSignatory === rowData} />
  );

  // const onSignatoryDocumentSelect = (rowData: any) => {
  //   const selected = [...selectedSignatory];
  //   const index = selected.findIndex(doc => doc.id === rowData.id);

  //   if (index === -1) {
  //     selected.push(rowData);
  //   } else {
  //     selected.splice(index, 1);
  //   }

  //   setSelectedSignatory(selected);
  // };
  const header = () => {
    return <span> Send Company Details to-<span style={{ color: "red" }}>({loginObj.name})  </span> </span>
  }

  return (
    //-----This is for Company Detail Information to send Mail---
    <Dialog visible={props.open} style={{ width: '50vw' }} header={header} modal className="p-fluid" onHide={onHide}>
      <DataTable value={tableData1} size="small" tableStyle={{ minWidth: '50rem' }} style={{ fontSize: '15px', marginBottom: '10px' }} showGridlines>
        <Column header="Select" body={companyDetailCheckboxTemplate} />
        <Column field="key" header="Company Detail" />
        <Column field="value" header="Company" />
      </DataTable>
      {/* ----Here I'm display the company document ----*/}
      <DataTable value={tableData} size="small" tableStyle={{ minWidth: '50rem' }} style={{ fontSize: '15px', marginBottom: '10px' }} showGridlines emptyMessage="No result found.">
        <Column header="Select" body={documentCheckboxTemplate} />
        <Column field="document_Names" header="Document Name" />
      </DataTable>

      {/* -----Here I'm display the Company's Signatory Information--------  */}
      <DataTable value={tableData2} size="small" tableStyle={{ minWidth: '50rem' }} style={{ fontSize: '15px', marginBottom: '10px' }} showGridlines emptyMessage="No result found.">
        <Column header="Select" body={signatoryCheckboxSelect} />
        <Column field="name" header="Signatory Name" />
        <Column field="designation" header="Designation" />
      </DataTable>
      {/*Send mail to login email  */}
      <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
        <div className="col-12 mb-3">
        </div>
        <div className="col-12 md:col-12 flex gap-4 justify-content-start">
          <Button style={{ width: '100px' }} label="SEND" type="submit"></Button>
          <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
        </div>
      </form>
    </Dialog>
  );
};
